// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"9ccc4dd5","245":"cf83ab14","246":"4fb3c3cd","485":"f7be3675","512":"4ad9893d","569":"647ff47a","950":"03f4073e"}[chunkId] + ".chunk.js";
};